import * as manageProjectType from './manageProjectType'
const useManageProjectType = (props: manageProjectType.UseManageProject) => {
    return {}
}

export default useManageProjectType
